import './Vehicles.scss';
import { reactPlugin } from '../../../../services/appInsights.service';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { Button, Form, ToggleButtonGroup, ToggleButton, Row, Col, Accordion } from 'react-bootstrap';
import { useEffect, useState, useContext } from 'react';
import { TesterVehicle } from '../../../../interfaces/tester.interface';
import { ConfirmationModelPopup, Toaster, ComponentModelPopup } from '../../../../interfaces/modal.interface';
import { TesterService } from '../../../../services/tester.service';
import EditVehicle from '../EditVehicle/EditVehicle';
import ConfirmationModel from '../../appUtilityComponent/ConfirmationModel/ConfirmationModel';
import ErrorComponentModel from '../../appUtilityComponent/ErrorComponentModel/ErrorComponentModel';
import ViewVehicle from '../ViewVehicle/ViewVehicle';
import _ from 'lodash';
import ToasterModel from '../../appUtilityComponent/ToasterModel/ToasterModel';
import Spinner from '../../../components/Spinner';
import { UserAuthContext, Authorize } from "../../appLoginComponent/UserAuthContext";

type TParams = { testerId: number, isNewTester: boolean };

function Vehicles({ testerId, isNewTester }: TParams) {

    let { isAuthorized } = useContext(UserAuthContext) as Authorize;

    let [vehicles, setVehicles] = useState([] as TesterVehicle[]);

    let [isShowLoading, setIsShowLoading] = useState(false as boolean);

    let [editVehicleId, setEditVehicleId] = useState(-1 as number);

    let [modalPopup, setModalPopup] = useState({} as ConfirmationModelPopup);

    let [searchVehicleType, setSearchVehicleType] = useState("" as string);

    let [searchIncident, setSearchIncident] = useState(false as boolean);

    let [searchEngineType, setSearchEngineType] = useState("" as string);

    let [searchText, setSearchText] = useState("" as string);

    let testerService = new TesterService();

    const onReset = () => {
        setSearchVehicleType("");
        setSearchIncident(false);
        setSearchEngineType("");
        setSearchText("");
    }
    const extractMessage = (source: any, fallback: string) =>
        source?.statusMessage?.statusMessage ||
        source?.response?.data?.statusMessage ||
        source?.message ||
        fallback;


    const onEdit = (vehicleId: number) => {
        setEditVehicleId(vehicleId);
    }

    const onDelete = (vehicle: TesterVehicle) => {
        setModalPopup({
            Title: "Are you sure you want to delete the " + (vehicle.vehicleTypeId === "1" ? "Vehicle" : "PDD") + "?",
            BodyMessageHtml: (`<div class="row"><div class="col-sm-12"><dl class="row">
                <div class="col-sm-4">
                <dt>YEAR</dt>
                <dd>`+ vehicle.year + `</dd>
                </div>
                <div class="col-sm-4">
                <dt>MAKE</dt>
                <dd>`+ vehicle.vehicleMake + `</dd>
                </div>
                <div class="col-sm-4">
                <dt>MODEL</dt>
                <dd>`+ vehicle.vehicleModel + `</dd>
                </div>
                </dl>
                <dl class="row">
                <div class="col-sm-12">`) +
                (vehicle.vehicleTypeId === "1" ? (`
                <dt>VIN</dt>
                <dd>` + vehicle.vin + `</dd>`) : (`
                <dt>UNIQUE ID</dt>
                <dd>` + vehicle.uniqueNumber + `</dd>`)) + (`
                </div>          
                </dl></div></div>`),
            OkText: "Delete",
            OkVariant: "btn-delete",
            Show: true,
            ShowCancel: true,
            CancelText: "Cancel",
            CancelVariant: "btn-cancel",
            HandleClose: onModalClose,
            HandleOk: () => { onModalClose(); onDeleteConfirmation(vehicle); }
        } as ConfirmationModelPopup);
    }

    const onCancel = (vehicleId: number) => {
        GetVehiclesByTesterId(testerId, false);
    }

    const onSave = (_message: string) => {
        GetVehiclesByTesterId(testerId, isNewTester);

        onToasterClose();

        setToaster({
            Title: "Success",
            Show: true,
            Message: _message,
            ShowSuccessCheck: true,
            ClassName: "toaster-success",
            OnClose: onToasterClose
        } as Toaster);
    }

    let [toaster, setToaster] = useState({} as Toaster);

    let [errorModal, setErrorModal] = useState({
        Title: "Error",
        Show: false,
        Component: null,
        HandleClose: () => setErrorModal({ ...errorModal, Show: false })
    } as ComponentModelPopup);

    const onToasterClose = () => {
        setToaster({} as Toaster);
    }

    const AddVehicleToList = () => {
        const joinedVehicles = vehicles.concat({ vehicleId: 0, testerId: testerId, isActive: "Y", vin: "", uniqueNumber: "", vehicleTypeId: "", DocumentsUploaded: ["1", "2", "3", "4", "5", "6"] } as TesterVehicle);
        const _newvehicles = _.clone(joinedVehicles);

        setEditVehicleId(0);
        setVehicles([]);
        setVehicles(_newvehicles);
    };

    async function onDeleteConfirmation(vehicle: TesterVehicle) {
        setIsShowLoading(true);
        vehicle.isActive = "N";

        testerService.SaveVehicle(vehicle).then(res => {
            if (res.statusCode === "N") {
                const errorMessage = extractMessage(res, "Failed to delete vehicle");
                console.error("SaveVehicle (delete) error:", errorMessage);
                setErrorModal({
                    Title: "Error",
                    Show: true,
                    Component: <div>{errorMessage}</div>,
                    HandleClose: () => setErrorModal({ ...errorModal, Show: false })
                });
                setIsShowLoading(false);
                return;
            }

            GetVehiclesByTesterId(testerId, isNewTester);

            var _message = ((vehicle.vehicleTypeId === "1") ? ("Vehicle " + vehicle.vin) : ("PDD " + vehicle.uniqueNumber)) + " has been deleted successfully.";

            onToasterClose();

            setToaster({
                Title: "Success",
                Show: true,
                Message: _message,
                ShowSuccessCheck: true,
                ClassName: "toaster-error",
                OnClose: onToasterClose
            } as Toaster);

            setIsShowLoading(false);
        }).catch((error: any) => {
            const message = extractMessage(error, "An unexpected error occurred while deleting vehicle");
            console.error("SaveVehicle (delete) exception:", error);
            setErrorModal({
                Title: "Error",
                Show: true,
                Component: <div>{message}</div>,
                HandleClose: () => setErrorModal({ ...errorModal, Show: false })
            });
            setIsShowLoading(false);
        });
    }

    async function GetVehiclesByTesterId(testerId: number, _isNewTester: boolean) {
        setIsShowLoading(true);

        try {
            var testerService = new TesterService();
            setVehicles([]);
            setEditVehicleId(0);

            const response = await testerService.GetVehiclesByTesterId(testerId);

            if (response.statusCode === "N") {
                const errorMessage = extractMessage(response, "Failed to fetch vehicles");

                setErrorModal({
                    Title: "Error",
                    Show: true,
                    Component: <div>{errorMessage}</div>,
                    HandleClose: () => setErrorModal({ ...errorModal, Show: false })
                });
                setIsShowLoading(false);
                return;
            }

            const _vehicles = response.result || [];

            if (_vehicles.length === 0) {
                setVehicles([{ vehicleId: 0, testerId: testerId, isActive: "Y", vin: "", uniqueNumber: "", vehicleTypeId: "", DocumentsUploaded: ["1", "2", "3", "4", "5", "6"] }] as TesterVehicle[]);
                setEditVehicleId(0);
            }
            else {
                if (_isNewTester) {
                    _vehicles.push({ vehicleId: 0, testerId: testerId, isActive: "Y", vin: "", uniqueNumber: "", vehicleTypeId: "", DocumentsUploaded: ["1", "2", "3", "4", "5", "6"] } as TesterVehicle);
                    setEditVehicleId(0);
                }
                else {
                    setEditVehicleId(-1);
                }
                setVehicles(_.clone(_vehicles));
            }
            setIsShowLoading(false);
        } catch (error: any) {
            const message = extractMessage(error, "An unexpected error occurred while fetching vehicles");
            console.error("GetVehiclesByTesterId exception:", error);
            setErrorModal({
                Title: "Error",
                Show: true,
                Component: <div>{message}</div>,
                HandleClose: () => setErrorModal({ ...errorModal, Show: false })
            });
            setIsShowLoading(false);
        }
    }

    useEffect(() => {
        GetVehiclesByTesterId(testerId, isNewTester);
    }, [testerId]);

    function onModalClose() {
        setModalPopup({} as ConfirmationModelPopup);
    }

    return (
        <>
            <ErrorComponentModel modal={errorModal} />
            <Accordion defaultActiveKey="0" className="accordion-parent">

                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <h5 className="mb-0">Vehicle Information</h5>
                    </Accordion.Header>
                    <Accordion.Body className="col-sm-12 mb-0">
                        {testerId > 0 &&
                            <div className="col-sm-12 vehicle-rows">
                                {
                                    vehicles?.some(x => x.vehicleId > 0) &&
                                    <div className="col-sm-12 border-bottom mb-2 pb-2">
                                        <Form>
                                            <Row>
                                                <Form.Group className={"mb-1 " + ((searchVehicleType && searchVehicleType.length > 0) ? "filled" : "")} as={Col} sm={12} lg={4}>
                                                    <ToggleButtonGroup
                                                        className="vehicle-type"
                                                        type="radio"
                                                        value={searchVehicleType}
                                                        name="vehicleTypeId">
                                                        <ToggleButton id="filter-all" className="shadow-none vehicle-type-button" onChange={e => setSearchVehicleType(e.target.value)} variant="light" value={""} style={{ flex: 1, minHeight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #6c757d', borderBottom: searchVehicleType === "" ? '2px solid #495057' : '2px solid #6c757d' }}>All</ToggleButton>
                                                        <ToggleButton id="filter-automated" className="shadow-none vehicle-type-button" onChange={e => setSearchVehicleType(e.target.value)} variant="light" value={"1"} style={{ flex: 1, minHeight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #6c757d', borderBottom: searchVehicleType === "1" ? '2px solid #495057' : '2px solid #6c757d' }}>Automated</ToggleButton>
                                                        <ToggleButton id="filter-pdd" className="shadow-none vehicle-type-button" onChange={e => setSearchVehicleType(e.target.value)} variant="light" value={"2"} style={{ flex: 1, minHeight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #6c757d', borderBottom: searchVehicleType === "2" ? '2px solid #495057' : '2px solid #6c757d' }}>PDD</ToggleButton>
                                                    </ToggleButtonGroup>
                                                </Form.Group>

                                                <Col xs={12} lg="auto">
                                                    <Form.Group className={"vehicle-filter-group " + ((searchEngineType && searchEngineType.length > 0) ? "has-value" : "") + " d-flex justify-content-center align-items-center"} style={{ position: 'relative' }}>
                                                        <Form.Control
                                                            autoComplete="off"
                                                            as="select"
                                                            className="vehicle-filter-control"
                                                            name="vehicleEngineType"
                                                            onChange={e => setSearchEngineType(e.target.value)}
                                                            value={searchEngineType}
                                                        >
                                                            <option value=""></option>
                                                            <option value="Gasoline">Gasoline</option>
                                                            <option value="Diesel">Diesel</option>
                                                            <option value="Electric">Electric</option>
                                                            <option value="Propane">Propane</option>
                                                            <option value="Hybrid">Hybrid</option>
                                                            <option value="Natural Gas">Natural Gas</option>
                                                            <option value="Compressed Gas">Compressed Gas</option>
                                                            <option value="Flex Fuel">Flex Fuel</option>
                                                            <option value="Other">Other</option>
                                                        </Form.Control>
                                                        <span style={{ position: 'absolute', right: '10px', pointerEvents: 'none', top: '50%', transform: 'translateY(-50%)' }} className='vehicle-filter-icon'></span>
                                                        <Form.Label>Engine Type</Form.Label>
                                                    </Form.Group>
                                                </Col>

                                                <Col xs={12} lg="auto">
                                                    <Form.Group className={"vehicle-filter-group " + ((searchText && searchText.length > 0) ? "has-value" : "")}>
                                                        <Form.Control
                                                            autoComplete="off"
                                                            type="text"
                                                            className="vehicle-filter-control"
                                                            name="SearchText"
                                                            onChange={e => setSearchText(e.target.value)}
                                                            value={searchText}
                                                        />
                                                        <Form.Label>Search</Form.Label>
                                                    </Form.Group>
                                                </Col>

                                                {isAuthorized("AV_View_Incidents") ? (
                                                    <Col xs={12} lg="auto" className="d-flex align-items-center justify-content-center">
                                                        <Form.Check
                                                            className="big-checkbox me-3 mt-0"
                                                            type="checkbox"
                                                            inline
                                                            onChange={(e) => setSearchIncident(e.target.checked)}
                                                            checked={searchIncident}
                                                            label="Incident"
                                                            style={{ gap: '8px' }}
                                                        />
                                                    </Col>
                                                ) : null}

                                                <Col xs={12} lg={2} className="text-end d-flex align-items-center justify-content-center">
                                                    <Button variant="light" className="btn-default btn-cancel" onClick={onReset}>
                                                        CLEAR
                                                    </Button>
                                                </Col>


                                            </Row>
                                        </Form>
                                    </div>
                                }
                                <div className="col-sm-12">
                                    {vehicles.filter(x =>
                                        (x.vehicleId <= 0) || (
                                            (x.isActive === "Y") &&
                                            (searchVehicleType.length === 0 || x.vehicleTypeId === searchVehicleType) &&
                                            (!searchIncident || x.incidentsCount > 0) &&
                                            (searchEngineType.length === 0 || x.vehicleEngineType === searchEngineType) &&
                                            (searchText.length === 0 || ((x.licensePlateNumber && x.licensePlateNumber.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                                                ||
                                                (x.vin && x.vin.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                                                ||
                                                (x.uniqueNumber && x.uniqueNumber.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                                                ||
                                                (x.vehicleMake && x.vehicleMake.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                                                ||
                                                (x.vehicleModel && x.vehicleModel.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                                            )))
                                    ).length === 0 &&
                                        <div className="row border-bottom pt-2 pb-2 font-bold">
                                            No results found.
                                        </div>
                                    }

                                    {vehicles.filter(x =>
                                        (x.vehicleId <= 0) || (
                                            (x.isActive === "Y") &&
                                            (searchVehicleType.length === 0 || x.vehicleTypeId === searchVehicleType) &&
                                            (!searchIncident || x.incidentsCount > 0) &&
                                            (searchEngineType.length === 0 || x.vehicleEngineType === searchEngineType) &&
                                            (searchText.length === 0 || ((x.licensePlateNumber && x.licensePlateNumber.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                                                ||
                                                (x.vin && x.vin.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                                                ||
                                                (x.uniqueNumber && x.uniqueNumber.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                                                ||
                                                (x.vehicleMake && x.vehicleMake.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                                                ||
                                                (x.vehicleModel && x.vehicleModel.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
                                            ))
                                        )
                                    ).map((vehicle: TesterVehicle, index: number) => (
                                        <div className={"row vehicle-row border-bottom pt-2 pb-2 " + (vehicle.incidentsCount > 0 ? "vehicle-warning" : "")} key={vehicle.vehicleId}>
                                            <div className="col mw-80px vehicle-number-wrapper">
                                                <div className="vehicle-number">{index + 1}</div>
                                            </div>
                                            <div className="col">
                                                {editVehicleId === vehicle.vehicleId ?
                                                    <EditVehicle vehicle={vehicle} onCancel={onCancel} onSave={onSave}></EditVehicle>
                                                    :
                                                    <ViewVehicle vehicle={vehicle} onEdit={onEdit} onDelete={onDelete} editVehicleId={editVehicleId}></ViewVehicle>
                                                }
                                            </div>
                                        </div>
                                    ))}
                                </div>


                            </div>
                        }
                        {testerId > 0 && editVehicleId < 0 &&
                            <div className="col-sm-12 mt-2 mb-2 pb-4 text-right">
                                <Button className="btn-default btn-save float-right" variant="light" onClick={AddVehicleToList}> Add Vehicle / PDD</Button>
                            </div>
                        }
                        <br />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <ConfirmationModel modal={modalPopup}></ConfirmationModel>
            <ToasterModel toaster={toaster}></ToasterModel>
            {isShowLoading && <Spinner></Spinner>}
        </>
    )
}

export default withAITracking(reactPlugin, Vehicles);
